import { render, staticRenderFns } from "./Extended.vue?vue&type=template&id=3a2c5bfc&scoped=true&"
import script from "./Extended.vue?vue&type=script&lang=js&"
export * from "./Extended.vue?vue&type=script&lang=js&"
import style0 from "./Extended.vue?vue&type=style&index=0&id=3a2c5bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2c5bfc",
  null
  
)

export default component.exports